/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressApiModel } from './addressApiModel';


export interface EmployeeDetailsUpdateApiModel { 
    id: number;
    addressDto: AddressApiModel;
    dateOfBirth: string;
    titleBeforeName: string;
    name: string;
    surname: string;
    titleAfterName: string;
    personalNumber?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    birthNumber?: string | null;
    activeStatus: boolean;
}

